// Konto firmowe: NIP w danych firmy (rejestracja konta firmowego, panel, import; tak samo płatności i publikacja).
// Nazwa firmy służy do wyświetlania, nie do rozpoznania.
export default function isFirm (user) {
    const nip = user?.dealer?.firm_nip
    return typeof nip === 'string' ? nip.trim() !== '' : Boolean(nip)
}
